// extracted by mini-css-extract-plugin
export default {"container":"QuickFilterBar_container__2d3lJ","negWidth":"QuickFilterBar_negWidth__8OAlr","filterLozenge":"QuickFilterBar_filterLozenge__uuZbW"};